import App from "./AppNedjeljniPrijenosDatoteka.svelte";
const app = new App({
    target: document.getElementById("a3_svelte_upload"),
    props: {},
});
export default app;
